import React, { useState, useCallback, createContext } from "react";

const SearchMessageContext = createContext();

const SearchMessageProvider = ({ children }) => {
	const [jumpRequest, setJumpRequest] = useState(null);
	const [inputFocusNonce, setInputFocusNonce] = useState(0);

	const requestJump = useCallback((messageId, targetPage) => {
		setJumpRequest({ messageId, targetPage, nonce: Date.now() });
	}, []);

	const requestInputFocus = useCallback(() => {
		setInputFocusNonce((nonce) => nonce + 1);
	}, []);

	return (
		<SearchMessageContext.Provider
			value={{ jumpRequest, requestJump, inputFocusNonce, requestInputFocus }}
		>
			{children}
		</SearchMessageContext.Provider>
	);
};

export { SearchMessageContext, SearchMessageProvider };
